import { Toggle } from '@/components/forms/Toggle';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConfirmationPrompt } from 'components/ConfirmationPrompt';
import Tooltip from 'components/tooltip/Tooltip';
import { useState } from 'react';
import { useTileEditorContext } from '../../contexts/TileEditorContext';
import { defaultSQL } from '../hooks/useDatasets';

const DisableAnalyticsPrompt: React.FC = () => {
    return <p>Warning: Only the first dataset will be retained when disabling SQL Analytics.</p>;
};

export const AnalyticsToggle: React.FC = () => {
    const { isDatasetMode, setTileConfig } = useTileEditorContext();
    const [disableModalOpen, setDisableModalOpen] = useState(false);

    const datasetModeChange = () => {
        setTileConfig((currentConfig) => {
            // If switching to multiple datasets mode, use the tile's config to form the first dataset
            if (!isDatasetMode) {
                return {
                    ...currentConfig,
                    visualisation: undefined,
                    timeframe: undefined,
                    scope: undefined,
                    dataStream: {
                        id: 'datastream-sql',
                        dataSourceConfig: {
                            version: '2.0',
                            sql: defaultSQL,
                            tables: [
                                {
                                    tableName: 'dataset1',
                                    config: {
                                        scope: currentConfig.scope,
                                        dataStream: currentConfig.dataStream,
                                        timeframe: currentConfig.timeframe,
                                        ...currentConfig.variables?.length && { variables: currentConfig.variables }
                                    }
                                }
                            ]
                        }
                    }
                };
            }

            // If switching from multiple datasets mode, use the first dataset to form the tile config
            return {
                _type: 'tile/data-stream',
                title: currentConfig.title,
                description: currentConfig.description,
                monitor: currentConfig.monitor,
                ...currentConfig.dataStream?.dataSourceConfig?.tables?.[0]?.config
            };
        });
    };

    return (
        <>
            <div className='flex items-center space-x-2'>
                <Toggle
                    name='analytics-toggle'
                    checked={isDatasetMode}
                    onCheckedChange={() => isDatasetMode ? setDisableModalOpen(true) : datasetModeChange()}
                    data-testid='analyticsToggle'
                />
                <label htmlFor='analytics-toggle' className='flex items-center space-x-2 select-none whitespace-nowrap'>
                    SQL Analytics
                    <Tooltip className='ml-2' title='SQL Analytics allows you to carry out advanced manipulation of data using a SQL query before you visualize it. [Learn more](https://docs.squaredup.com/advanced-features/sql-analytics-beta)'>
                        <FontAwesomeIcon className='text-textSecondary opacity-70' fixedWidth icon={faQuestionCircle} />
                    </Tooltip>
                </label>
                
            </div>

            {disableModalOpen && (
                <ConfirmationPrompt
                    title={'Disable SQL Analytics'}
                    prompt={<DisableAnalyticsPrompt />}
                    confirmButtonText='Continue'
                    confirmButtonVariant='destructive'
                    onClose={() => setDisableModalOpen(false)}
                    onConfirm={datasetModeChange}
                />
            )}
        </>
    );
};
